import { render, staticRenderFns } from "./UnsolicitedCalleeEffect.vue?vue&type=template&id=4478cfbd&scoped=true&"
import script from "./UnsolicitedCalleeEffect.vue?vue&type=script&lang=js&"
export * from "./UnsolicitedCalleeEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4478cfbd",
  null
  
)

export default component.exports